/*global process*/
import getCookie from "../getCookie";
import fetchSQS from "./fetchSQS";

//This accesses the SOUP server which people call REST
export const sourceOneRestURL =
   process.env.BUILD === "development"
      ? `https://eclipse-wally/rest/1.0/sourceone`
      : `${window.location.origin}/rest/1.0/sourceone`;

export const SQSUrl =
   process.env.BUILD === "development"
      ? `http://localhost:8000/sourceone/sqs/`
      : `https://${window.location.host}/sourceone/sqs/`;

export const staticURL =
   process.env.BUILD === "development" ? "/static/" : "/sourceone/static/";

export async function getECLToken() {
   //If no cookie, call refresh-token, then get the cookie
   let accessToken = getCookie("ecltoken");
   if (!accessToken) {
      await fetchSQS("refresh-token", "GET").catch((error) =>
         console.error(error),
      );
      accessToken = getCookie("ecltoken");
      if (!accessToken) {
         throw new Error("Could not refresh access token");
      }
   }
   return accessToken;
}

export function sourceOneRESTFetchConfig(accessToken) {
   return {
      method: "POST",
      headers: {
         "Content-type": "application/json",
         Authorization: `Bearer ` + accessToken,
      },
   };
}
